// Shared Web Push subscribe/unsubscribe logic. Kept in one place so the
// automatic on-load prompt and the manual Settings toggle can't drift apart.

const VAPID_PUBLIC_KEY = "BNMSiRaptMAcZNby8iS1ggjxb_frec62Gp1jCvMMDa17VR2DteB4l7LAqlpguosyk8DTIhmIjAouMZUUQGTLM1k";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

// Returns: "unsupported" | "denied" | "on" | "off"
// "off" covers both "never asked yet" and "granted but not subscribed" —
// both are states where enablePush() can proceed without re-prompting
// if permission was already granted.
export async function getPushStatus() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return sub ? "on" : "off";
}

// Requests permission if needed, subscribes, and saves the subscription +
// device timezone to Supabase. Returns the resulting Notification.permission
// value ("granted" | "denied" | "default") so callers can react accordingly.
export async function enablePush(supabase, userId) {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return permission;

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }
  const j = sub.toJSON();
  await supabase.from("push_subscriptions").upsert(
    { user_id: userId, endpoint: j.endpoint, p256dh: j.keys.p256dh, auth: j.keys.auth },
    { onConflict: "endpoint" }
  );
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";
  await supabase.from("profiles").update({ timezone: tz }).eq("id", userId);
  return "granted";
}

export async function disablePush(supabase) {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await supabase.from("push_subscriptions").delete().eq("endpoint", sub.endpoint);
    await sub.unsubscribe();
  }
}
